export default __webpack_public_path__ + "static/media/akkumlyator.27620d9c.jpg";